import { BLOCKS } from '@contentful/rich-text-types'

function insertItem(content, position, item) {
  const contentList = [...content]
  contentList.splice(position, 0, item)

  return contentList
}

export function relatedPostsConverter(content, similarPosts = []) {
  let contentList = [...content]

  const relatedPosts = {
    nodeType: 'related-posts',
    content: [],
    data: { similarPosts },
  }
  const heading2 = content.filter((el) => el.nodeType === BLOCKS.HEADING_2)
  if (heading2.length > 1) {
    const relatedPostPosition = contentList.indexOf(heading2[1])
    contentList = insertItem(content, relatedPostPosition, relatedPosts)
  } else if (heading2.length === 1) {
    const relatedPostPosition = contentList.indexOf(heading2[0])
    contentList = insertItem(content, relatedPostPosition, relatedPosts)
  } else {
    contentList = insertItem(content, 0, relatedPosts)
  }

  return contentList
}
